<mat-card class="card-base-section provision-user-card">
  <div class="card-header flex-it flex-row flex-xcontent-center">
    <button mat-icon-button (click)="goBack()" aria-label="Back">
      <ng-icon
        name="HeroArrowLeft"
        aria-hidden="true"
        class="icon-fw"
      ></ng-icon>
    </button>
    <div class="card-header-title">Provision a new CXS user</div>
    <div class="card-header-division"></div>
  </div>
  <div class="card-content">
    <div class="provision-sections">
      <section>
        <!--User info-->
        <div class="flex-it flex-row flex-xcontent-center">
          <ng-icon name="HeroUser" aria-hidden="true" class="icon-fw"></ng-icon>
          <h3 class="ml-2">User info</h3>
        </div>
        <form class="provision-user-form" [formGroup]="form">
          <mat-form-field>
            <mat-label>Email</mat-label>
            <ng-icon
              name="HeroMail"
              aria-hidden="true"
              class="icon-fw"
              matSuffix
            ></ng-icon>
            <input
              type="email"
              matInput
              placeholder="Ex. aperson@concentrix.com"
              [formControl]="email"
            />
            @if (email.hasError("required")) {
              <mat-error> Email is <strong>required</strong> </mat-error>
            }
            @if (email.hasError("email")) {
              <mat-error> Please enter a valid email address </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>Password</mat-label>
            <input
              [type]="hidePassword ? 'password' : 'text'"
              matInput
              [formControl]="password"
            />
            <ng-icon
              [name]="hidePassword ? 'HeroEye' : 'HeroEyeOff'"
              class="icon-fw"
              matSuffix
              (click)="hidePassword = !hidePassword"
              [attr.title]="hidePassword ? 'Show Password' : 'Hide Password'"
              [attr.aria-label]="
                hidePassword ? 'Show password' : 'Hide password'
              "
              aria-live="polite"
            ></ng-icon>
            @if (password.hasError("required")) {
              <mat-error> Password is <strong>required</strong> </mat-error>
            }
            @if (password.hasError("minlength")) {
              <mat-error>
                Password must contain at least
                {{ PASSWORD_MIN_LENGTH }} characters
              </mat-error>
            }
          </mat-form-field>
        </form>
      </section>

      <section>
        <!--Workspaces-->
        @if (workspaceOptions.length > 0) {
          <h3>Workspaces</h3>
          <span>You can add or remove them again, later.</span>
          <div class="workspaces flex-it flex-col">
            @for (option of workspaceOptions; track option) {
              <div>
                <mat-checkbox [(ngModel)]="option.selected">
                  @if (!option.isOwner) {
                    <span>{{ option.workspace.label }}*</span>
                  }
                  @if (option.isOwner) {
                    <span>{{ option.workspace.label }}</span>
                  }
                </mat-checkbox>
              </div>
            }
          </div>
          <div>
            <i>* workspace you do not own</i>
          </div>
        }
      </section>
    </div>

    <!--Submit-->
    <button
      mat-raised-button
      color="primary"
      class="provision-button"
      [disabled]="!form.valid"
      (click)="provisionUser()"
    >
      Provision user
    </button>
  </div>
</mat-card>
